import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

/**
 * Live priority preview controller.
 * When urgency and impact selects change, shows the calculated priority badge.
 *
 * data-controller="support--priority-matrix"
 * data-support--priority-matrix-url-value="/support/tickets/calculate_priority"
 */
export default class extends Controller {
  static targets = ["urgency", "impact", "display"]
  static values = { url: String }

  // Default priority matrix (mirrors Support::CalculatePriority::DEFAULT_MATRIX)
  static MATRIX = {
    high_high: {
      name: "Critical",
      key: "p1",
      class: "bg-red-100 text-red-800",
    },
    high_medium: {
      name: "High",
      key: "p2",
      class: "bg-orange-100 text-orange-800",
    },
    high_low: {
      name: "Medium",
      key: "p3",
      class: "bg-yellow-100 text-yellow-800",
    },
    medium_high: {
      name: "High",
      key: "p2",
      class: "bg-orange-100 text-orange-800",
    },
    medium_medium: {
      name: "Medium",
      key: "p3",
      class: "bg-yellow-100 text-yellow-800",
    },
    medium_low: { name: "Low", key: "p4", class: "bg-blue-100 text-blue-800" },
    low_high: {
      name: "Medium",
      key: "p3",
      class: "bg-yellow-100 text-yellow-800",
    },
    low_medium: { name: "Low", key: "p4", class: "bg-blue-100 text-blue-800" },
    low_low: {
      name: "Planning",
      key: "p5",
      class: "bg-gray-100 text-gray-800",
    },
  }

  calculate() {
    const urgency = this.urgencyTarget.value
    const impact = this.impactTarget.value

    if (!urgency || !impact) {
      this.displayTarget.classList.add("hidden")
      return
    }

    const key = `${urgency}_${impact}`
    const priority = this.constructor.MATRIX[key]

    if (priority) {
      this.displayTarget.innerHTML = `
        <div class="rounded-lg border border-border bg-card/50 p-4">
          <div class="flex items-center gap-3">
            <div>
              <p class="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-1">Calculated Priority</p>
              <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${priority.class}">
                ${priority.name}
              </span>
              <p class="text-xs text-muted-foreground mt-1">
                Based on ${urgency.charAt(0).toUpperCase() + urgency.slice(1)} urgency and ${impact.charAt(0).toUpperCase() + impact.slice(1)} impact
              </p>
            </div>
          </div>
        </div>
      `
      this.displayTarget.classList.remove("hidden")
    }
  }
}
